import CategoryUsageStatsContainer from 'components/feature/statistics/category/CategoryUsageStatsContainer';

const CategoryUsageStatsPage = () => {
  return <CategoryUsageStatsContainer />;
};
export default CategoryUsageStatsPage;
